import { getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { env } from '@/config/env';

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
}
export const getFirebaseConfig = (): FirebaseConfig => ({
  apiKey: env.firebaseApiKey,
  authDomain: env.firebaseAuthDomain,
});

// Lazy initialization keeps missing deployment configuration on the login page.
export function getFirebaseAuth(): Auth {
  const config = getFirebaseConfig();
  if (Object.values(config).some(value => !value || value.startsWith('{VITE_'))) {
    throw new Error('Google sign-in is not configured. Please contact your administrator.');
  }
  const app: FirebaseApp = getApps()[0] ?? initializeApp(config);
  return getAuth(app);
}
